import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import RichContent from '@components/RichContent/RichContent';
import { IMedicationShareResponseDetails } from '@interfaces/medications';
import { getParsedText } from '@views/AdminInquiriesPage/AdminInquiryList/SupplementInquiryDetails/SupplementInformationForm/utils';
import SupplementResponseDetailsField from '@views/InquiryResponsePage/SupplementResponseDetails/SupplementResponseDetailsBody/SupplementResponseDetailsField/SupplementResponseDetailsField';

import './style.scss';

interface IProps {
  item: IMedicationShareResponseDetails;
  className: string;
}

const PrintResponseMedicationCard: FC<IProps> = ({ className, item }) => {
  const { t } = useTranslation();

  return (
    <div className={cn('print-response-card', className)}>
      <div className="print-response-card__row print-response-card__header">
        <div className="print-response-card__name">{item.name}</div>
      </div>

      <div className="print-response-card__row print-response-card__details">
        <div className="print-response-card__section">
          <SupplementResponseDetailsField
            className="print-response-card_margin-t-0"
            label={t('inquiryResponse.comments')}
          >
            {item.comments ? <RichContent>{getParsedText(item.comments)}</RichContent> : '-'}
          </SupplementResponseDetailsField>
        </div>
      </div>

      <div className="print-response-card__row">
        <SupplementResponseDetailsField
          className="print-response-card_margin-t-0 print-response-card__link"
          label={t('inquiryResponse.viewProductPage')}
        >
          {item.productLink || '-'}
        </SupplementResponseDetailsField>
      </div>
    </div>
  );
};

export default PrintResponseMedicationCard;
